import styled, { keyframes } from "styled-components";

export const PaletteContainer = styled.div`
  max-width: 500px;
  margin: 10px auto;
  border: 1px solid var(--gray);
  // border-radius: 16px;
  overflow: hidden;
`;

export const Tiles = styled.div`
  display: flex;
  flex-direction: row;
`;

export const labelScale = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

export const Tile = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 1%;
  position: relative;
  transition: flex-basis 0.15s ease;
  transition-delay: 0.1s;
  background: ${(props) => props.$background};
  &:hover,
  &:focus {
    flex-basis: 25%;
  }
  &:hover .label,
  &:focus .label {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    transition-delay: 0.15s;
  }
`;

export const Label = styled.span`
  font-size: 16px;
  font-weight: 700;
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${(props) => (props.lightLabel ? "#fff" : "#000")};
`;

export const PaletteInfo = styled.div`
  border-top: 1px solid var(--gray);
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
    font-size: 20px;
  }
  span {
    vertical-align: middle;
    font-weight: 700;
    font-size: 14px;
  }
`;

export const TileSmall = styled.span`
  border-top: 1px solid var(--gray);
  display: inline-block;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  margin-right: 8px;
  vertical-align: middle;
  background: ${(props) => props.background};
`;
